import AppACL from '@/plugins/acl/ACL'
import { AuthLayout, DefaultLayout, PrintLayout } from '@/components/layouts'
import SessionHelper from '@/helpers/SessionHelper'

export const publicRoute = [
  {
    path: '*',
    component: () => import('@/views/error/NotFound.vue'),
  },
  {
    path: '/auth',
    component: AuthLayout,
    meta: { title: 'Login' },
    redirect: '/auth/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        meta: { title: 'Login' },
        component: () => import('@/views/auth/Login.vue'),
      },
    ],
  },

  {
    path: '/404',
    name: '404',
    meta: { title: 'Not Found' },
    component: () => import('@/views/error/NotFound.vue'),
  },

  {
    path: '/500',
    name: '500',
    meta: { title: 'Server Error' },
    component: () => import('@/views/error/Error.vue'),
  },
]

export const protectedRoute = [
  {
    path: '/',
    component: DefaultLayout,
    redirect: '/dashboard',
    meta: { title: 'Root' },
    children: [
      {
        path: '403',
        name: 'Forbidden',
        meta: { title: '403' },
        component: () => import('@/views/error/Deny.vue'),
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        meta: {
          title: 'Dashboard',
          roles: [
            AppACL.ROLE.GEM,
            AppACL.ROLE.ADM,
            AppACL.ROLE.COL,
            AppACL.ROLE.DIST,
            AppACL.ROLE.LAB,
          ],
        },
        component: () => import('@/views/Dashboard.vue'),
      },

      {
        path: 'notificaciones',
        name: 'Notificaciones',
        meta: {
          title: 'Notificaciones',
          roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
        },
        component: () => import('@/views/Notificaciones.vue'),
      },

      {
        path: 'logs',
        name: 'Logs',
        meta: {
          title: 'Logs',
          roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
        },
        component: () => import('@/views/Logs.vue'),
      },

      // Seccion de Laboratorios
      {
        path: 'laboratorios',
        name: 'Laboratorios',
        redirect: '/laboratorios/listado',
        meta: {
          title: 'Laboratorios',
          roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
        },
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: 'listado',
            name: 'Listado-Laboratorios',
            meta: {
              title: 'Listado de Laboratorios',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/laboratorios/List.vue'),
          },
          {
            path: 'nuevo',
            name: 'Nuevo-Laboratorio',
            meta: {
              title: 'Nuevo Laboratorio',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/laboratorios/Form.vue'),
          },
          {
            path: 'editar/:id',
            name: 'Editar-Laboratorio',
            meta: {
              title: 'Editar Laboratorio',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/laboratorios/Form.vue'),
          },
        ],
      },
      // Seccion de Distribuidores
      {
        path: 'distribuidores',
        name: 'Distribuidores',
        redirect: '/distribuidores/listado',
        meta: {
          title: 'Distribuidores',
          roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
        },
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: 'listado',
            name: 'Listado-Distribuidores',
            meta: {
              title: 'Listado de Distribuidores',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/distribuidores/List.vue'),
          },
          {
            path: 'nuevo',
            name: 'Nuevo-Distribuidor',
            meta: {
              title: 'Nuevo Distribuidor',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/distribuidores/Form.vue'),
          },
          {
            path: 'editar/:id',
            name: 'Editar-Distribuidor',
            meta: {
              title: 'Editar Distribuidor',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/distribuidores/Form.vue'),
          },
        ],
      },

      // Seccion de Productos
      {
        path: 'productos',
        name: 'Productos',
        redirect: '/productos/listado',
        meta: { title: 'Productos' },
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: 'listado',
            name: 'Listado-Productos',
            meta: {
              title: 'Listado de Productos',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/productos/List.vue'),
          },
          {
            path: 'nuevo',
            name: 'Nuevo-Producto',
            meta: {
              title: 'Nuevo Producto',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/productos/Form.vue'),
          },
          {
            path: 'expirados',
            name: 'Productos Expirados',
            meta: {
              title: 'Productos Expirados',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/productos/Expired.vue'),
          },
          {
            path: 'editar/:id',
            name: 'Editar-Producto',
            meta: {
              title: 'Editar Producto',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/productos/Form.vue'),
          },
        ],
      },

      // Seccion de Usuarios
      {
        path: 'usuarios',
        name: 'Usuarios',
        redirect: '/productos/listado',
        meta: { title: 'Usuarios' },
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: 'listado',
            name: 'Listado-Usuarios',
            meta: {
              title: 'Listado de Usuarios',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/usuarios/List.vue'),
          },
          {
            path: 'nuevo',
            name: 'Nuevo-Usuario',
            meta: {
              title: 'Nuevo Usuario',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/usuarios/Form.vue'),
          },
          {
            path: 'editar/:id',
            name: 'Editar-Usuario',
            meta: {
              title: 'Editar Usuario',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/usuarios/Form.vue'),
          },
        ],
      },

      // Seccion de Facturas
      {
        path: 'facturas',
        name: 'Facturas',
        redirect: '/facturas/listado',
        meta: { title: 'Facturas' },
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: 'listado',
            name: 'Listado-Facturas',
            meta: {
              title: 'Listado de Facturas',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/facturas/List.vue'),
          },
          {
            path: 'nuevo',
            name: 'Nueva-Factura',
            meta: {
              title: 'Nueva Factura',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/facturas/Form.vue'),
          },
          {
            path: 'editar/:id',
            name: 'Editar-Factura',
            meta: {
              title: 'Editar Factura',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/facturas/Form.vue'),
          },
        ],
      },

      // Seccion de Transit
      {
        path: 'transit',
        name: 'Transit',
        redirect: '/transit/facturas',
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: 'facturas',
            name: 'Transit-Facturas',
            meta: {
              title: 'Facturas',
              roles: [
                AppACL.ROLE.GEM,
                AppACL.ROLE.ADM,
                AppACL.ROLE.DIST,
                AppACL.ROLE.LAB,
                AppACL.ROLE.COL,
              ],
            },
            component: () => import('@/views/transit/Facturas.vue'),
          },

          {
            path: 'f&d',
            name: 'F&D',
            meta: {
              title: 'F&D',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.COL, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/transit/F&D.vue'),
          },
          {
            path: 'aprobadas',
            name: 'Aprobadas',
            meta: {
              title: 'Aprobadas',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.COL, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/transit/Aprobadas.vue'),
          },
          {
            path: 'rechazadas',
            name: 'Rechazadas',
            meta: {
              title: 'Rechazadas',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.COL, AppACL.ROLE.ADM],
            },
            component: () => import('@/views/transit/Rechazadas.vue'),
          },
          {
            path: 'pago-de-impuestos',
            name: 'PagoImpuestos',
            meta: {
              title: 'Facturación',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM, AppACL.ROLE.PAG],
            },
            component: () => import('@/views/transit/PagoImpuestos.vue'),
          },
          {
            path: 'entregas',
            name: 'Entregas',
            meta: {
              title: 'Entregas',
              roles: [AppACL.ROLE.GEM, AppACL.ROLE.ADM, AppACL.ROLE.ENT],
            },
            component: () => import('@/views/transit/Entregas.vue'),
          },

          {
            path: 'ver-facturas',
            name: 'Transit-Clientes',
            meta: {
              title: 'Facturas',
              roles: [AppACL.ROLE.DIST, AppACL.ROLE.LAB],
            },
            component: () => {
              if (SessionHelper.role === 'LAB')
                return import('@/views/transit/FacturasLaboratorio.vue')
              if (SessionHelper.role === 'DIST')
                return import('@/views/transit/FacturasDistribuidor.vue')
            },
          },
        ],
      },
    ],
  },
  {
    path: '/print-invoice/:id',
    name: 'PrintInvoice',
    meta: {
      title: 'Print Invoice',
      roles: [
        AppACL.ROLE.ADM,
        AppACL.ROLE.GEM,
        AppACL.ROLE.DIST,
        AppACL.ROLE.LAB,
      ],
    },
    component: PrintLayout,
  },
]
